import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PlayerService {

   // Observable player state
   private playerStateSource = new Subject<boolean>();

   // Player state stream
   playerState$ = this.playerStateSource.asObservable();

   setPlayerState(state: boolean) {
      this.playerStateSource.next(state);
   }
}
